import { Division, EmptyState, Heading, Icons, Paragraph, Spin } from "@ir/ui";
import { useConfigBrand } from "./ConfigBrandContext";

export const ConfigBrandHomePage = () => {
  const {
    brand,
    organization,
    isBrandSelected,
    isLookupLoading,
    organizationKey,
    brandKey,
  } = useConfigBrand();

  if (isLookupLoading && organizationKey && brandKey) {
    return (
      <Division className="config-brand-home">
        <Spin tip="Loading brand..." />
      </Division>
    );
  }

  if (!isBrandSelected || !brand || !organization) {
    return null;
  }

  const brandLabel = brand.brandDisplayName ?? brand.brandName;
  const orgLabel =
    organization.organizationDisplayName ?? organization.organizationName;

  return (
    <Division className="config-brand-home">
      <Heading level={6} className="text-grey-700 font-bold m-0 mb-1">
        {brandLabel}
      </Heading>
      <Paragraph className="text-grey-500 m-0 mb-3">
        Brand in {orgLabel}
      </Paragraph>
      <EmptyState
        icon={Icons.List}
        title="Select a Configuration category"
        description="Use the left navigation to open Data Provider and manage Portal Credentials for this brand."
      />
    </Division>
  );
};
